import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import AddForm from './Viewall'
import { Box } from '@chakra-ui/react';

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="Deposit Voucher"
                breadcrumb={["Dashboard", "Voucher", "Deposit List"]}
            />
            <Box p={6}>

                <AddForm />
            </Box>
        </div>
    )
}

export default Liability